import { useSelector } from 'react-redux';

import { getDocument } from '@app/store/signingProgressInformation/selectors';

function RequesterInfo() {
  const document = useSelector(getDocument);

  return (
    <div className="box-5x">
      <h5 className="space-3x">서명 요청자 정보</h5>
      <p className="space-1x">
        <b>
          {document?.requester ? `${document.requester.name} (${document.requester.email})` : null}
        </b>
      </p>
      <table className="InfoTable">
        <tbody>
          <tr>
            <th className="InfoTable__label-cell">인증 상태</th>
            <td className="InfoTable__value-cell">모두싸인 가입 인증 완료</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default RequesterInfo;
